//src/services/users.api.js
import { apiRequest } from "./api";

export const getMe = () => {
  return apiRequest("/users/me");
};

export const updateMe = (data) => {
  return apiRequest("/users/me", {
    method: "PUT",
    body: JSON.stringify(data),
  });
};
